import { styled } from '@mui/material';
import { MaterialDesignContent } from 'notistack';

const StyledNotificationSuccess = styled(MaterialDesignContent)(({ theme }) => ({
	'&.notistack-MuiContent-success': {
		backgroundColor: '#FFFFFFB2',
		backdropFilter: 'blur(10px)',
		padding: '8px 16px',
		borderRadius: '10px',
		borderLeft: `4px solid ${theme.palette.success.contrastText}`,
		color: theme.palette.text.black,
	},
}));

export default StyledNotificationSuccess;
